import {
  IntegrationTermsAndConditions,
  IntergrationInstructionStep,
  StrVal
} from '../../../../lib/api/account-linking/types';

export function IsIntegrationValid(
  values: StrVal,
  steps: IntergrationInstructionStep[],
  termsAndConditions: IntegrationTermsAndConditions
): boolean {
  let output = true;

  steps.forEach((step) => {
    step.inputs?.forEach((input) => {
      const val = values[input.propertyName] || '';
      if (input.validationRules.required && !val) {
        output = false;
      }
      if (input.validationRules.pattern && val && !new RegExp(input.validationRules.pattern).test(val)) {
        output = false;
      }
    });
  });

  if (termsAndConditions) {
    const input = termsAndConditions.input;
    const val = values[input.propertyName] || '';
    if (input.validationRules.required && !val) {
      output = false;
    }
    if (input.validationRules.pattern && val && !new RegExp(input.validationRules.pattern).test(val)) {
      output = false;
    }
  }

  return output;
}

export function ValidationErrorMessages(validationErrors: { [name: string]: string }, errorCode: string): string[] {
  const msg: string[] = [];
  switch (errorCode) {
    case '1000':
      msg.push('We are unable to find your account.');
      break;

    case '1001':
      msg.push('This account already exists.');
      break;

    case '1002':
      msg.push('The integration version you are using is not supported.');
      break;

    case '1003':
      msg.push('We can not verify the credentials you have entered.');
      break;

    default: {
      try {
        for (const m in validationErrors) {
          msg.push((validationErrors[m] as any)[0].message);
        }
      } catch {
        console.log('Error parsing validation errors');
      }
    }
  }

  return msg.length > 0 ? msg : ['Unable to link account, please try again.'];
}
